"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CodeMirrorEditor = require("codemirror");
require("codemirror/lib/codemirror.css");
require("codemirror/theme/monokai.css");
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/mllike/mllike");
require("codemirror/mode/rust/rust");
var TextArea_1 = require("semantic-ui-react/dist/commonjs/addons/TextArea/TextArea");
var semantic_ui_react_12 = require("semantic-ui-react");
var Segment_3 = require("semantic-ui-react/dist/commonjs/elements/Segment/Segment");
var Lang;
(function (Lang) {
    Lang["Javascript"] = "javascript";
    Lang["OCaml"] = "ocaml";
    Lang["Output"] = "result";
    Lang["Reason"] = "reason";
})(Lang = exports.Lang || (exports.Lang = {}));
var langToOptions = {
    javascript: {
        gutters: ["gutter-js"],
        lineNumbers: false,
        mode: "rust",
        readOnly: "nocursor"
    },
    ocaml: {
        gutters: ["gutter-ocaml"],
        lineNumbers: false,
        mode: "mllike",
        readOnly: "nocursor"
    },
    reason: {
        gutters: ["gutter-reason"],
        lineNumbers: true,
        mode: "javascript"
    },
    result: {
        gutters: ["gutter-result"],
        lineNumbers: false,
        mode: "javascript",
        readOnly: "nocursor",
        theme: "neat"
    }
};

var CodeMirror = function (_React$Component) {
    (0, _inherits3.default)(CodeMirror, _React$Component);

    function CodeMirror() {
        (0, _classCallCheck3.default)(this, CodeMirror);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CodeMirror.__proto__ || Object.getPrototypeOf(CodeMirror)).apply(this, arguments));

        _this.defaultOptions = {
            gutters: ["my-gutter"],
            lineNumbers: true,
            mode: "rust",
            theme: "monokai"
        };
        return _this;
    }

    (0, _createClass3.default)(CodeMirror, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            var langOptions = langToOptions[this.props.lang];
            var editorOptions = (0, _extends3.default)({}, this.defaultOptions, langOptions, this.props.options);
            this.editor = CodeMirrorEditor.fromTextArea(this.containerDiv, editorOptions);
            this.editor.setValue(this.props.value);
            this.editor.on("change", function (cm, metadata) {
                var value = _this2.editor.getValue();
                if (value !== _this2.props.value && _this2.props.onEditorChange) {
                    _this2.props.onEditorChange(value);
                }
            });
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var hasChanged = this.props.value !== nextProps.value && nextProps.value !== this.editor.getValue();
            if (hasChanged) {
                this.editor.setValue(nextProps.value);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return React.createElement(Segment_3.default, { vertical: true, basic: true }, React.createElement(semantic_ui_react_12.Ref, { innerRef: function innerRef(textarea) {
                    return _this3.containerDiv = textarea;
                } }, React.createElement(TextArea_1.default, null)));
        }
    }]);
    return CodeMirror;
}(React.Component);

exports.default = CodeMirror;
;


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/home/travis/build/codekiln/gradus-reason/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/components/CodeMirror/CodeMirror.tsx